import React from 'react';
import { NeedFromAbby } from './NeedFromAbby';
type PhotoPlaceholderProps = {
  src: string;
  alt: string;
  note?: string;
  className?: string;
  imgClassName?: string;
  eager?: boolean;
};

/** Stand-in photography, flagged until Abby's brand photos arrive. */
export function PhotoPlaceholder({
  src,
  alt,
  note = 'brand photo',
  className = '',
  imgClassName = '',
  eager = false
}: PhotoPlaceholderProps) {
  return <figure className={`relative overflow-hidden bg-stone ${className}`} data-id="element-322" data-mp="35lh6h2klepbo">
      <img src={src} alt={alt} loading={eager ? 'eager' : 'lazy'} className={`h-full w-full object-cover ${imgClassName}`} data-id="element-323" data-mp="3ak0tz7eu4965" />
      <NeedFromAbby className="absolute left-3 top-3" data-id="element-324" data-mp="3k8sgv151g3a7">{note}</NeedFromAbby>
    </figure>;
}